import { createSlice } from "@reduxjs/toolkit";
import { beforePlay, inPlay } from "../types/userModeTypes";
export const userModeSlice = createSlice({
  name: "userMode",
  initialState: {
    userModeState: beforePlay,
    matchState: inPlay,
  },
  reducers: {
    changeUserMode: (state, action) => {
      state.userModeState = action.payload;
    },

    changeMatchState: (state, action) => {
      state.matchState = action.payload;
    },
    reset: (state) => {
      state.userModeState = beforePlay;
      state.matchState = inPlay;
    },
  },
});

export const { changeMatchState, changeUserMode, reset } =
  userModeSlice.actions;

export default userModeSlice.reducer;
